module.exports = __webpack_public_path__ + "img/domicile2.44086613.jpg";